define.alias("ember-composable-helpers/helpers/shuffle", "settings/helpers/shuffle");